import React from 'react';
import {
    Box, TextField, FormControl, InputAdornment, InputLabel, Input, IconButton, Button,
    Typography, Select, MenuItem, FormHelperText, Alert, List, ListItem, ListItemText, ListItemButton, Chip
} from '@mui/material';
import { AccountCircleOutlined, Visibility, VisibilityOff, LockOutlined, Group } from '@mui/icons-material';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch, } from 'react-redux';
import { set } from 'lodash';
import { Tabs } from '../../components/tabs';
import { Grid } from '../../components/table';
import { CONFIG } from '../../../config'
import axios from 'axios';
import { ToolBar } from '../../components/toolbar';
import { Modal } from '../../components/modal';
import { FormA } from '../../components/form';
import moment from 'moment';
import { getFormState } from '../../../helpers/form';
import dayjs from 'dayjs';
import IosShareIcon from '@mui/icons-material/IosShare';
const  weekday = require('dayjs/plugin/weekday')
dayjs.extend(weekday)

const API_HOST = CONFIG.modules['accounts'].host
const API_HOST_CRM = CONFIG.modules['crm'].host






export const CallsView = (props) => {
    const { roles, user, users, Designations, Departments, Languages, Districts } = useSelector((state) => (state.user || {}))

    const [data, setData] = useState([])
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(25);
    const [count, setCount] = useState(0)
    const [filter, setFilter] = useState({
        from: dayjs(),
        to: dayjs(),
    })

    const getCalls = () => {
        setData([])
        axios.get(API_HOST_CRM + `/cases/by-agent?limit=${rowsPerPage}&page=${page}&user=${user._id}${
            filter.from?`&from=${dayjs(filter.from).format('YYYY-MM-DD')}`:''
            }${filter.to?`&to=${dayjs(filter.to).format('YYYY-MM-DD')}`:''}${filter.motherID?`&motherID=${filter.motherID}`:''}
            ${filter.status?`&status=${filter.status}`:''}`)
            .then((resp) => {
                if (resp.data && resp.data.success) {
                    setData(resp.data.ecd)
                    setCount(resp.data.count)
                }

            }).catch((e) => {

                console.log(e)
            })
    }

    useEffect(() => {
        getCalls()
    }, [])
    useEffect(() => {
        getCalls()
    }, [filter, page,rowsPerPage])

  

    return (
        <>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
             
                {/* <Box sx={{ width: 200 }}>
                    <List>
                        <ListItem disablePadding>
                            <ListItemButton>

                                <ListItemText primary="Today's Report" /> <Chip label="Export" variant="outlined" onClick={() => {
                                    exportReport(new Date())
                                }} />
                            </ListItemButton>
                        </ListItem>
                     
                    </List>
                </Box> */}
                <ToolBar name={'Calls'}
                 buttons={[
                    // {
                    //     name: 'Export',
                    //     // type: 'chip',
                    //     icon: () => <IosShareIcon sx={{ fontSize: '1.2em' }} />,
                    //     onClick: () => {
                    //         exportReport(new Date())
                    //     }
                    // }
                    {
                        name: 'Today',
                        // type: 'chip',
                        // icon: () => <IosShareIcon sx={{ fontSize: '1.2em' }} />,
                        onClick: () => {
                            setFilter({...filter, from: dayjs(), to: dayjs()})
                        }
                    },
                    {
                        name: 'This week',
                        // type: 'chip',
                        // icon: () => <IosShareIcon sx={{ fontSize: '1.2em' }} />,
                        onClick: () => {
                            const start = dayjs().weekday(-7)
                            const end = start.add(6,'day')
                            // console.log(start.format('DD-MM-YYYY'), end.format('DD-MM-YYYY'))
                            setFilter({...filter, from: start, to: end})

                        }
                    }
                ]}


                filters={[
                    // {
                    //     field: {
                    //         name: 'status',
                    //         type: 'select',
                    //         label: 'Status',
                    //         option: { key: 'Status', value: '_id', label: 'name' },

                    //     },
                    //     data:{
                    //         Status:
                    //             ['Any','Pending', 'Active','No answer', 'Call done', 'Busy', 'No network', 'Invalid',
                    //                 'Incoming not available', 'Not in the portal',
                    //                 'Miscarriage', 'Call Incomplete', 'Deceased Child', 'Switched off', 'Wrong number', 'Declined',
                    //                 'Out of service', 'Language Barrier', 'Deceased Mother', 'Deceased (Mother and Child)', 'Duplicate Mother Id'
                    //             ].map(d => ({ _id: d, name: d }))
                    //     },
                    //     onChange: (name, value) => {
                    //         filter[name] = value
                    //         setFilter({...filter})
                    //     },
                    //     state: filter

                    // },
                    {
                        field: {
                          name: "motherID",
                          type: "text",
                          label: "Mother ID",
                        
                        },
                        onChange: (name, value) => {
                          filter[name] = value;
                          setFilter({ ...filter });
                        },
                        state: filter,
                      },
                    {
                        field: {
                            name: 'from',
                            type: 'date',
                            label: 'From',
                        },
                        onChange: (name, value) => {
                            filter[name] = value
                            setFilter({...filter})
                        },
                        state: filter

                    },
                    {
                        field: {
                            name: 'to',
                            type: 'date',
                            label: 'To',
                        },
                        onChange: (name, value) => {
                            filter[name] = value
                            setFilter({...filter})
                        },
                        state: filter

                    }
                ]}
                    />
                <Box sx={{ mt: 2 }}>
                    <Grid data={data} columns={[
                        { id: 'motherID', label: 'Mother ID', minWidth: 40 },
                        { id: 'name', label: 'Name', minWidth: 70 },
                        // { id: 'age', label: 'Age', minWidth: 40 },
                        { id: 'contact', label: 'Contact', minWidth: 70 },


                        // { id: 'week', label: 'Week', minWidth: 50 },
                        // { id: 'pregnancyMonth', label: 'Month', minWidth: 40 },
                        // { id: 'trimester', label: 'Trimester', minWidth: 40 },
                        // { id: 'pregnancyStatus', label: 'Pregnancy Status', minWidth: 40 },
                        { id: 'districtName', label: 'District', minWidth: 50 },
                        { id: 'langName', label: 'Language', minWidth: 70, format: (data, row)=>{
                            return data||'NA'
                        } },

                        // { id: 'cluster', label: 'Cluster', minWidth: 40 },
                        { id: 'dataType', label: 'Data Type', minWidth: 40 },


                        { id: 'status', label: 'Status', minWidth: 50 },
                        {
                            id: 'callDate', label: 'Call Date', minWidth: 70, format: (data, row) => {
                                return data ? dayjs(data).format('DD-MM-YYYY') : ''
                            }
                        },
                        {
                            id: 'duration', label: 'Duration', minWidth: 70, format: (data, row) => {
                                return data || ''
                            }
                        },
                        {
                            id: 'callStartTime', label: 'Call Start Time', minWidth: 70, format: (data, row) => {
                                return data ? dayjs(data).format('HH:mm:ss') : ''
                            }
                        },
                        {
                            id: 'callEndTime', label: 'Call End Time', minWidth: 70, format: (data, row) => {
                                return data ? dayjs(data).format('HH:mm:ss') : ''
                            }
                        },
                        // { id: 'sankalpId', label: 'Sankalp Data', minWidth: 50, format: (data, row) => {
                        //     if(data) {
                        //         return (<Button onClick={() => {
                        //             setOpen(true)
                        //             setSelectedSankalpData(data)
                        //         }}>View</Button>)
                        //     } else {
                        //         return ''
                        //     }
                        // } },

                    ]}

                        pagination={{
                            rowsPerPageOptions: [10, 25, 50],
                            page,
                            rowsPerPage,
                            onPageChange: (event, newPage) => {
                                setPage(newPage);
                            },
                            onRowsPerPageChange: (event) => {
                                setRowsPerPage(+event.target.value);
                                setPage(0);
                            },
                            count
                        }}
                    >

                    </Grid>
                </Box>


            </Box>


        </>
    )
}